<div class="p-4">
  <form [formGroup]="form" class="pb-3">
    <div class="p-fluid">
      <div class="field">
        <div class="ui-widget field-label">
          <label for="formReferenceCode">Reference Code</label>
        </div>
      </div>
    </div>
    <div class="flex">
      <input id="formReferenceCode"
             formControlName="formReferenceCode"
             type="text"
             pInputText
             class="p-inputtext p-component p-element flex-grow-1">
      <button pripple pautofocus type="button" class="p-ripple p-element p-button p-component ml-2 m-0"
              (click)="retrieveForm()">
        Retrieve
      </button>
    </div>
  </form>
</div>
<div class="p-4">
  <div class="p-fluid">
    <div class="field">
      <div class="ui-widget field-label">
        <label for="formReferenceCode">Make a new form submission</label>
      </div>
    </div>
  </div>
  <div *ngFor="let form of availableForms">
    <a href="javascript:void(0)" (click)="loadBlankForm(form.applicationId, form.template)">{{ form.formName }}</a>
  </div>
</div>
